import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Result = () => {
     useEffect(() => {
        document.title = 'Interaction and Entrance Examination Result -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
            
          </li>
          <li>  Admission  </li>
          <li>Interaction and Entrance Examination Result </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Interaction and Entrance Examination Result  </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3>
              Interaction and  Entrance Examination Result for the test conducted on 8th November 2025.
              </h3>

               
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                    <th>S.NO </th>
                    <th>	STUDENT'S NAME </th>
                    <th>	CLASS </th>
                    <th>	FATHER' S NAME </th> 
                    <th>	MOTHER'S NAME </th>
                   {/* <th>	CONTACT NUMBER</th>*/}
                    
                    </tr>
                  </thead>
                  <tbody>
                  <tr><td>1</td><td>LEYAN MAGGU</td><td>NUR</td><td>MR. LOHIT MAGGU</td><td>MRS. ANITA</td>{/*<td>9355636902</td>*/}</tr>
                  <tr><td>2</td><td>DEVYA</td><td>NUR</td><td>MR. VIKASH GARG</td><td>MRS. KRISHNA GARG</td>{/*<td>9968951665</td>*/}</tr>
                  <tr><td>3</td><td>HARSHIL CHAUDHARY</td><td>NUR</td><td>MR. RAHUL CHAUDHARY</td><td>MRS. DEEPANSHI</td>{/*<td>8437319169</td>*/}</tr>
                  <tr><td>4</td><td>SAMYUKTA</td><td>NUR</td><td>MR. SUMIT KUKRETI</td><td>MRS. ANJALI KUKRETI</td>{/*<td>7290999017</td>*/}</tr>
                  <tr><td>5</td><td>AARAV MANNA</td><td>NUR</td><td>MR. GAURAV MANNA</td><td>MRS. KIRAN MANNA</td>{/*<td>971738263</td>*/}</tr>
                  <tr><td>6</td><td>ARNAV KUKREJA</td><td>NUR</td><td>MR. VIVEK KUKREJA</td><td>MRS. KAVITA</td>{/*<td>8588957934</td>*/}</tr>
                  <tr><td>7</td><td>NOEL JOSE</td><td>NUR</td><td>MR. JOBY</td><td>MRS. NINCY</td>{/*<td>9873153476</td>*/}</tr>
                  <tr><td>8</td><td>RIDHIMA</td><td>NUR</td><td>MR. AMIT</td><td>MRS. GEETA</td>{/*<td>9210789450</td>*/}</tr>
                  <tr><td>9</td><td>GURBAAZ SINGH</td><td>NUR</td><td>MR. SURPREET</td><td>MRS. AMANPREET</td>{/*<td>8800944907</td>*/}</tr>
                  <tr><td>10</td><td>KASHVI VERMA</td><td>LKG</td><td>MR. SHIV KUMAR</td><td>MRS. KOMAL</td>{/*<td>9871402735</td>*/}</tr>
                  <tr><td>11</td><td>PARTH NARWAT</td><td>LKG</td><td>MR. DEEPAK DAGAR</td><td>MRS. RAKHI DAGAR</td>{/*<td>8920991617</td>*/}</tr>
                  <tr><td>12</td><td>GAURANG BHARDWAJ</td><td>LKG</td><td>MR. YATIN</td><td>MRS BHARTI</td>{/*<td>9812631922</td>*/}</tr>
                  <tr><td>13</td><td>KHUSHANK VERMA</td><td>LKG</td><td>MR. GOURAV</td><td>MRS. HEMA VERMA</td>{/*<td>9899110139</td>*/}</tr>
                  <tr><td>14</td><td>SHANAYA GUPTA</td><td>LKG</td><td>MR. SUBHASH KUMAR</td><td>MRS. BHARTI</td>{/*<td>7503048290</td>*/}</tr>
                  <tr><td>15</td><td>AVYAAN GUPTA</td><td>LKG</td><td>MR. RAJESH</td><td>MRS. PURNIMA</td>{/*<td>9910477115</td>*/}</tr>
                  <tr><td>16</td><td>VAMIKA BHUDHIRAJA</td><td>LKG</td><td>MR. ANIL</td><td>MRS. NEENA</td>{/*<td>9810930652</td>*/}</tr>
                  <tr><td>17</td><td>SAMARTH YADAV</td><td>LKG</td><td>MR. ASHWANI</td><td>MRS. SIMRAN</td>{/*<td>9997924432</td>*/}</tr>
                  <tr><td>18</td><td>PARTH BHATIA</td><td>LKG</td><td>MR. ANUP</td><td>MRS. KAMLESH</td>{/*<td>9319757070</td>*/}</tr>
                  <tr><td>19</td><td>AVANTIKA BANSAL</td><td>LKG</td><td>MR. RAHUL</td><td>MRS. VARSHA</td>{/*<td>7417660742</td>*/}</tr>
                  <tr><td>20</td><td>TUSHIKA JHANGRA</td><td>LKG</td><td>MR. ISHWAR SINGH</td><td>MRS. SHAKUNTALA</td>{/*<td>9416837902</td>*/}</tr>
                  <tr><td>21</td><td>AARADHYA NEGI</td><td>LKG</td><td>MR. HEMANT</td><td>MRS. GANGA</td>{/*<td>7503390647</td>*/}</tr>
                  <tr><td>22</td><td>AVYUKTH DASH</td><td>UKG</td><td>MR. SATYAJIT DASH</td><td>MRS. PRAGYA</td>{/*<td>7978708588</td>*/}</tr>
                  <tr><td>23</td><td>LUVISH BAIJAL</td><td>UKG</td><td>MR. VIKAS</td><td>MRS. DOLLY</td>{/*<td>9313642135S</td>*/}</tr>
                  <tr><td>24</td><td>AVANYA DHYANI</td><td>UKG</td><td>MR. ANKIT</td><td>MRS. KIRAN</td>{/*<td>9718624534</td>*/}</tr>
                  <tr><td>25</td><td>AAYRA DHYANI</td><td>UKG</td><td>MR. ANKIT</td><td>MRS. KIRAN</td>{/*<td>9718624534</td>*/}</tr>
                  <tr><td>26</td><td>AANSHI JAIN</td><td>UKG</td><td>MR. ANKUR</td><td>MRS. SHALINI</td>{/*<td>9997565600</td>*/}</tr>
                  <tr><td>27</td><td>TWISHA JAIN</td><td>I</td><td>MR. SACHIN</td><td>MRS. KINSHU</td>{/*<td>7015515803</td>*/}</tr>
                  <tr><td>28</td><td>JARSHIKA</td><td>I</td><td>MR. ROBIN</td><td>MRS. PRIYANKA</td>{/*<td>9319930024</td>*/}</tr>
                  <tr><td>29</td><td>VANSH JINDAL</td><td>I</td><td>MR. SUNIL</td><td>MRS. MANJU</td>{/*<td>8130252910</td>*/}</tr>
                  <tr><td>30</td><td>ARHANSH BISHT</td><td>I</td><td>MR. MOHIT</td><td>MRS. SUSHMA</td>{/*<td>9988800735</td>*/}</tr>
                  <tr><td>31</td><td>AARAV SHUKLA</td><td>I</td><td>MR. BHAVNA SHUKLA</td><td>SWAPNIL SHUKLA</td>{/*<td>9858539419</td>*/}</tr>
                  <tr><td>32</td><td>KUNWAR ALUNA CHOUDHARY</td><td>I</td><td>MR. SACHIN</td><td>MRS. POONAM</td>{/*<td>7508203018</td>*/}</tr>
                  <tr><td>33</td><td>DARSH SODHI</td><td>II</td><td>MR. GAURAV</td><td>MRS. JITENDER KAUR</td>{/*<td>8700774727</td>*/}</tr>
                  <tr><td>34</td><td>NAKSH TANEJA</td><td>II</td><td>MR. HEMANT</td><td>MRS. SUNITI</td>{/*<td>9711756020</td>*/}</tr>
                  <tr><td>35</td><td>TIARA SAXENA</td><td>III</td><td>MR. ASHWIN</td><td>MRS. DEEPALI</td>{/*<td>8285686656</td>*/}</tr>
                  <tr><td>36</td><td>CHAITANYA KAUSHIK</td><td>III</td><td>MR. SUNIL</td><td>MRS VARSHA</td>{/*<td>9911313564</td>*/}</tr>
                  <tr><td>37</td><td>PRITHVI KUMAR</td><td>III</td><td>MR. PAREEN</td><td>MRS. NEETU</td>{/*<td>9015375466</td>*/}</tr>
                  <tr><td>38</td><td>ANIKA KUNTAL</td><td>III</td><td>MR. PRANAVIR SINGH</td><td>MRS. GAYATRI DEVI</td>{/*<td>9911761960</td>*/}</tr>
                  <tr><td>39</td><td>GAURANSHI</td><td>IV</td><td>MR. GAURAV</td><td>MTS. JITENDER KAUR</td>{/*<td>8700774727</td>*/}</tr>
                  <tr><td>40</td><td>SHANAYA PARVANDA</td><td>V</td><td>MR. VARUN</td><td>MRS. VEENU</td>{/*<td>8800544467</td>*/}</tr>
                  <tr><td>41</td><td>ARIANNA SARAH CHARAN</td><td>V</td><td>MR. ASHISH</td><td>MRS. LEENA</td>{/*<td>7042731987</td>*/}</tr>
                  <tr><td>42</td><td>SAMARTH JINDAL</td><td>V</td><td>MR. SUNIL</td><td>MRS. MANJU</td>{/*<td>8130252910</td>*/}</tr>
                  <tr><td>43</td><td>SAMRAN SAXENA</td><td>VI</td><td>MR. ASHWIN</td><td>MRS. DEEPALI</td>{/*<td>8285686656</td>*/}</tr>
                  <tr><td>44</td><td>RUHIKA</td><td>VII</td><td>MR. RAMESH</td><td>MRS. SUNITA</td>{/*<td>9255089310</td>*/}</tr>
                  <tr><td>45</td><td>DEVANSHI SHARMA</td><td>VII</td><td>MR.</td><td></td>{/*<td></td>*/}</tr>
                  <tr><td>46</td><td>TUSHITA GUJJRAL</td><td>IX</td><td>MR. VIKAS</td><td>MRS. RAJNI</td>{/*<td>9310169491</td>*/}</tr>
                  </tbody>
                </table>
              </div> 
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Result
